import styles from './Profil.module.css'
import { IoIosContact } from "react-icons/io";

export default function Profil({image}) {

    return(
        <div className={styles.profilBox}>
            
            {image ? (
                <div className={styles.img} style={{ backgroundImage: `url(${image})` }}></div>
            ) : (
                <div className={styles.img} style={{ display: "flex", alignItems: "center", justifyContent: "center"}}>
                    <IoIosContact size={100} color="#666" />
                </div>
            )}
        </div>
    );
}